module.exports = __webpack_public_path__ + "static/media/receipts_active.bcc3dc95.svg";